// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-root {
  width: 100%;
  border: 1px solid var(--Global-Neutral-Grey-500, #e6e6e6);
  border-radius: 16px;
  background-color: white;
}

.container-header {
  display: flex;
  padding: 16px 24px;
  justify-content: space-between;
  border-bottom: 1px solid var(--Global-Neutral-Grey-500, #e6e6e6);
  height: 76px;
  align-items: center;
}

.conatiner-content {
  display: flex;
  justify-content: center;
  height: 308px;
}

.conatiner-content .MuiTableContainer-root {
  padding: 12px 24px 12px 24px;
}
.conatiner-content .pie-chart {
  padding: 28px 24px;
}
.conatiner-content .table-skeleton {
  padding: 28px 24px;
}
.conatiner-content .funnel-div {
  padding: 28px 24px;
}
.conatiner-content .funnel-skeleton {
  padding: 28px 24px;
}

.conatiner-content
  .MuiTableContainer-root
  .MuiTableCell-root
  .MuiButtonBase-root {
  flex-direction: row;
}

.conatiner-content
  .MuiTableContainer-root
  .MuiTableCell-root
  .MuiButtonBase-root
  .MuiSvgIcon-root {
  margin-right: -2px;
}

.container-tabs {
  display: flex;
  padding: 4px;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--Global-Neutral-Grey-200, #f8f8f8);
}

.active-tab {
  display: flex;
  height: 32px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  background: var(--Global-Base-White, #fff);
  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);
  cursor: pointer;
}

.inActive-tab {
  display: flex;
  height: 32px;
  padding: 0px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  cursor: pointer;
}

.active-tab-font.MuiTypography-root {
  color: var(--Global-Neutral-Grey-1300, #0a090b);
  /* Semibold/14 */
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.02px;
}

.inActive-tab-font.MuiTypography-root {
  color: #4f4d55 !important;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.05px;
}

.container-subheader.MuiTypography-root {
  color: var(--Global-Neutral-Grey-1000, #4f4d55);
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}

.filters-and-tabs {
  display: flex;
  align-items: center;
  gap: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/reusableComponents/conatinerWithTabs/conatinerWithTab.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,yDAAyD;EACzD,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,8BAA8B;EAC9B,gEAAgE;EAChE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;;;;EAKE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,0CAA0C;EAC1C,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAE,aAAa;EAChC,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX","sourcesContent":[".container-root {\n  width: 100%;\n  border: 1px solid var(--Global-Neutral-Grey-500, #e6e6e6);\n  border-radius: 16px;\n  background-color: white;\n}\n\n.container-header {\n  display: flex;\n  padding: 16px 24px;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--Global-Neutral-Grey-500, #e6e6e6);\n  height: 76px;\n  align-items: center;\n}\n\n.conatiner-content {\n  display: flex;\n  justify-content: center;\n  height: 308px;\n}\n\n.conatiner-content .MuiTableContainer-root {\n  padding: 12px 24px 12px 24px;\n}\n.conatiner-content .pie-chart {\n  padding: 28px 24px;\n}\n.conatiner-content .table-skeleton {\n  padding: 28px 24px;\n}\n.conatiner-content .funnel-div {\n  padding: 28px 24px;\n}\n.conatiner-content .funnel-skeleton {\n  padding: 28px 24px;\n}\n\n.conatiner-content\n  .MuiTableContainer-root\n  .MuiTableCell-root\n  .MuiButtonBase-root {\n  flex-direction: row;\n}\n\n.conatiner-content\n  .MuiTableContainer-root\n  .MuiTableCell-root\n  .MuiButtonBase-root\n  .MuiSvgIcon-root {\n  margin-right: -2px;\n}\n\n.container-tabs {\n  display: flex;\n  padding: 4px;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: var(--Global-Neutral-Grey-200, #f8f8f8);\n}\n\n.active-tab {\n  display: flex;\n  height: 32px;\n  padding: 0px 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 6px;\n  background: var(--Global-Base-White, #fff);\n  box-shadow: 0px 1.5px 4px -1px rgba(10, 9, 11, 0.07);\n  cursor: pointer;\n}\n\n.inActive-tab {\n  display: flex;\n  height: 32px;\n  padding: 0px 12px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.active-tab-font.MuiTypography-root {\n  color: var(--Global-Neutral-Grey-1300, #0a090b);\n  /* Semibold/14 */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px; /* 142.857% */\n  letter-spacing: -0.02px;\n}\n\n.inActive-tab-font.MuiTypography-root {\n  color: #4f4d55 !important;\n  font-family: Poppins;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px; /* 142.857% */\n  letter-spacing: -0.05px;\n}\n\n.container-subheader.MuiTypography-root {\n  color: var(--Global-Neutral-Grey-1000, #4f4d55);\n  font-family: Poppins;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 18px;\n}\n\n.filters-and-tabs {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
